<template>
  <footer class="site-footer">
    <div>Copyright Public Service Company of Colorado {{ thisYear() }} - All Rights Reserved</div>
  </footer>
</template>

<script setup>
import { thisYear } from '@shared/utils/date'
</script>
